module.exports = __webpack_public_path__ + "assets/img/17.60f908d2.png";